import { Toolbar } from "react-admin";
import { ReferenceInput } from "react-admin";
import styled from "styled-components";
import { Button as MuiButton } from "@material-ui/core";

export const StyledToolbar = styled(Toolbar)`
  && {
    display: flex;
    justify-content: flex-start;
    gap: 16px;
    padding: 16px 0;
    border-top: 1px solid #e0e0e0;
  }
`;

export const StyledReferenceInput = styled(ReferenceInput)`
  & .MuiInputBase-root {
    background-color: #fff;
  }
`;

export const ToolbarCancelMuiButton = styled(MuiButton)`
  && {
    color: #1976d2;
    text-transform: none;
    font-size: 14px;
    font-weight: 500;
    &:hover {
      background-color: transparent;
    }
  }
`;

/** type="button" — não submete o form; o envio real ocorre após confirmação no modal. */
export const ToolbarSendMuiButton = styled(MuiButton).attrs({
  variant: "contained",
  type: "button",
})`
  && {
    box-shadow: none;
    text-transform: none;
    font-size: 14px;
    font-weight: 500;
    padding: 8px 36px;
  }
  &&[data-send-valid="true"]:not(:disabled) {
    background-color: #1976d2;
    color: #fff;
    &:hover {
      background-color: #1565c0;
    }
  }
  &&[data-send-valid="false"],
  &&:disabled {
    background-color: #e0e0e0 !important;
    color: #9e9e9e !important;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 0 24px 120px 24px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: -16px -24px 2px -40px;
  padding: 24px;
  background-color: #fafafa;
  border-radius: 0;
  box-sizing: border-box;
  border-bottom: 1px solid #e0e0e0;
`;

export const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #000;
  margin: 0;
  line-height: 1.2;
`;

export const Subtitle = styled.p`
  font-size: 14px;
  color: #666;
  margin: 0;
  line-height: 1.4;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-right: 24px;
`;
